import { useMemo } from 'react';
import type { ToastData } from './toast-component';
import { getGlobalToastQueue } from './toast-queue';

interface ShowToastConfig {
  timeout?: number;
  onClose?: () => void;
}

const DEFAULT_TOAST_CONFIG: ShowToastConfig = { timeout: 5000 };

export function showToast(
  newToast: ToastData,
  config: ShowToastConfig = DEFAULT_TOAST_CONFIG
): string {
  const queue = getGlobalToastQueue();
  const toastsBeforeAdd = queue.visibleToasts;
  const key = queue.add(newToast, config);

  // react-stately queues overflow toasts to resurface later. We drop them instead. If the visible count didn't grow, the stack was full, so close toast that got pushed out
  if (queue.visibleToasts.length === toastsBeforeAdd.length) {
    const evictedToast = toastsBeforeAdd.at(-1);
    if (evictedToast) {
      queue.close(evictedToast.key);
    }
  }

  return key;
}

export function useToast() {
  return useMemo(
    () => ({
      showToast,
      clearToasts: (): void => {
        getGlobalToastQueue().clear();
      },
    }),
    []
  );
}
